import { getRgObjectsOfType as n, RG_TYPE as e } from "@project-rouge/rg-core";
import { applyTransform as i } from "../../../geometry-utils/core/index2.js";
import { getPivot as r } from "../../../geometry-utils/three/index12.js";
import { Vectors as c } from "../../../utils/index36.js";
import { V3toVector3 as m } from "../../../geometry-utils/index9.js";
const s = c.Back, p = 0.9807, R = (t) => n(t, e.Apartment).filter(a).length;
function a(t) {
  let o = r([0.5, 0, 0], t).sub(r([0.5, 0, 1], t));
  return t.parent && (o = m(i(o, t.parent))), o.y = 0, o.normalize(), s.dot(o) > p;
}
export {
  R as countNorthFacingUnits
};
//# sourceMappingURL=index.js.map
